import React from "react"

import * as S from "./styled.js"

const Button = ({ children, ...props }) => (
  <S.Button {...props} className="btn w-full lg:text-2xl bg-gradient">{children}</S.Button>
)

export default Button
